import { __assign, __rest } from "tslib";
import React from 'react';
import { FacebookShareButton, TumblrShareButton, TwitterShareButton, } from 'react-share';
export var ShareButton = function (_a) {
    var type = _a.type, url = _a.url, title = _a.title, via = _a.via, _b = _a.hashtags, hashtags = _b === void 0 ? [] : _b, _c = _a.media, media = _c === void 0 ? url : _c, children = _a.children, props = __rest(_a, ["type", "url", "title", "via", "hashtags", "media", "children"]);
    switch (type) {
        case 'facebook':
            return (React.createElement(FacebookShareButton, __assign({ quote: title, hashtag: hashtags.length ? "#".concat(hashtags[0]) : '', url: url }, props), children));
        case 'twitter':
            return (React.createElement(TwitterShareButton, __assign({ url: url, title: title, via: via, hashtags: hashtags }, props), children));
        case 'tumblr':
            return (React.createElement(TumblrShareButton, __assign({ url: url, title: title, tags: hashtags, caption: title }, props), children));
        default:
            return null;
    }
};
ShareButton.displayName = 'ShareButton';
export default ShareButton;
//# sourceMappingURL=ShareButton.js.map